module.exports = __webpack_public_path__ + "bt.svg?ef7c8f8136abc8d0d168c910108be21d";